import { colors as _, ETheme } from '@opiumteam/react-opium-components'

export const getScrollConfig = (theme: string) => {
  return {
    trackYProps: { style: { backgroundColor: '#8b8b8b1a', width: '5px' } },
    thumbYProps: { style: { backgroundColor: theme === ETheme.DARK ? '#ffffff1a' : '#0a0a1e1a', width: '5px', borderRadius: '10px' } }
  }
}
